<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item class="bold"
                >Cấu hình chấm công</el-breadcrumb-item
              >
              <el-breadcrumb-item>Cấu hình kỳ lương</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div>
            <div class="text-right mb-2">
                <!-- <el-button
                  @click="showHideAddNewSalary()"
                  round
                >
                  Thêm mới
                </el-button> -->
              </div>
          </div>
        </div>
        <div class="main-body mt-3">
          <div class="main-body-table">
            <el-table
              :data="mData.tableRules.data"
              border
              @selection-change="fn_tableSelectionChange"
              @sort-change="fn_tableSortChange"

              style="width: 100%"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column
                type="selection"
                width="40"
                v-if="mData.tableRules.allowSelect"
              ></el-table-column>
              <el-table-column
                prop=""
                label="Tên kỳ"
                min-width="250"
              ></el-table-column>
              <el-table-column
                prop=""
                label="Thời gian từ"
                min-width="150"
              ></el-table-column>
              <el-table-column
                prop=""
                label="Thời gian tới"
                min-width="150"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      title="Thêm mới kỳ lương"
      :visible.sync="mData.dialogFormAddNewSalary"
    >
      <el-form
        ref="myForm"
        label-position="top"
        @submit.native.prevent
        label-width="135px"
      >
        <b-row>
          <b-col cols="12">
            <el-form-item prop="">
              <div slot="label" class="d-flex at-center">
                <p>Tên kỳ lương</p>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="this is content, this is content, this is content"
                  placement="bottom"
                >
                  <i
                    class="fas fa-info-circle fa-lg"
                    style="margin-left: 10px"
                  ></i>
                </el-tooltip>
              </div>
              <el-input
                clearable
              ></el-input>
            </el-form-item>
          </b-col>
          <b-col md="6">
            <el-form-item label="Thời gian từ" prop="">
              <el-date-picker type="date" placeholder=""> </el-date-picker>
            </el-form-item>
          </b-col>
          <b-col md="6">
            <el-form-item label="Thời gian tới trước" prop="">
              <el-date-picker type="date" placeholder=""> </el-date-picker>
            </el-form-item>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <el-form-item label="Tuỳ chọn lặp lại" prop="">
              <el-select class="mb-3" clearable filterable>
                <el-option
                  v-for="item in mData.dataDefault.listChuKy"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <el-form-item label="Thời gian hiệu lực từ" prop="">
              <el-date-picker type="date" placeholder=""> </el-date-picker>
            </el-form-item>
          </b-col>
          <b-col md="6">
            <el-form-item label="Thời gian hiệu lực tới" prop="">
              <el-date-picker type="date" placeholder=""> </el-date-picker>
            </el-form-item>
          </b-col>
          <b-col md="12">
            <el-form-item label="Quy tắc đặt tên" prop="">
              <el-select class="mb-3" clearable filterable>
                <el-option
                  v-for="item in mData.dataDefault.listQuyTac"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </b-col>
        </b-row>
        <div class="text-center mb-0">
          <el-button round
            >Thêm</el-button
          >
        </div>
      </el-form>
    </el-dialog> -->
  </div>
</template>

<script>
import MethodService from "../../../../../service/MethodService";
import SalaryPeriodConfigModel from "./SalaryPeriodConfigModel";
import TemplateSalaryPeriodApi from '../../../../../moduleApi/TemplateSalaryPeriodApi';

export default {
  data() {
    return {
      mData: {
        data: [],
        moduleName: "SalaryPeriodConfigList", //requied
        dialogFormAddNewSalary: false,
        tableRules: MethodService.copyObject(
          SalaryPeriodConfigModel.tableRules
        ),
        dataDefault: {
          file: "",
          listChuKy: [
            {
              value: "",
              label: "",
            },
          ],
          listQuyTac: [
            {
              value: "",
              label: "",
            },
          ],
        },
      },
    };
  },

  methods: {
    async fn_initTable() {
      const templateSalaryPeriodApiRes = await TemplateSalaryPeriodApi.list();
    },
    showHideAddNewSalary() {
      this.mData.dialogFormAddNewSalary = !this.mData.dialogFormAddNewSalary;
    },
    //event table
    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
  },

  //run after render view
  created() {
    this.fn_initTable();
  },
  mounted() {},
};
</script>
<style scoped>
::v-deep .el-dialog {
  width: 60%;
}
</style>
